import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Router } from 'react-router-dom';
import history from '~/services/history';
import './config/ReactotronConfig';
import Routes from './routes';
import GlobalStyle from './style/globalStyle';
import { store, persistor } from './store';
import Toastify from './components/Toastify';

export default function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <Toastify />
          <Routes />
          <GlobalStyle />
        </Router>
      </PersistGate>
    </Provider>
  );
}
